<template>
  <div class="mini-toasts">
    <transition-group name="toast">
      <div class="toast" :key="toast.id" v-for="toast in toasts">
        <i class="icon ion-checkmark-round"></i>
        Added
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as mutationTypes from 'store/mutationTypes'
import store from 'store'

export default {
  name: 'mini-toasts',
  data() {
    return {}
  },
  computed: {
    ...mapState({
      toasts: (state) => state.miniToasts.toasts,
    }),
  },
  methods: {
    onMutation(mutation) {
      if (mutation.type === mutationTypes.ADD_MINI_TOAST) {
        const newToast = mutation.payload

        setTimeout(() => {
          this.removeToast(newToast)
        }, newToast.timeout)
      }
    },
    removeToast(toast) {
      this.$store.dispatch('removeMiniToast', toast)
    },
  },
  mounted() {
    this.storeUnsubscribe = store.subscribe(this.onMutation)
  },
  destroyed() {
    this.storeUnsubscribe()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/MiniToasts.vue